/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
import { Container, Grid } from "@mui/material";
import { FC } from "react";

const Account: FC = () => {
  
  return (
    <Container>
      <>
        <Grid
          container
          alignItems="stretch"
          columnSpacing={4}
          rowSpacing={2}
        ></Grid>
      </>
    </Container>
  );
};
export default Account;
